const shuffleArray = (array) => {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

const getVerbKey = (verb, index) => {
  const root = (verb?.['שורש'] || verb?.root || '').trim();
  const lemma = (verb?.['פועל'] || verb?.lemma3ms || '').trim();
  const binyan = (verb?.['בניין'] || verb?.binyan || '').trim();

  return `${binyan}|${root || lemma || index}|${lemma}`;
};

export function buildImperativeRoundPlan(verbs, pronouns, totalRounds) {
  const uniqueByVerb = new Map();

  (verbs || []).forEach((verb, index) => {
    const key = getVerbKey(verb, index);
    if (!uniqueByVerb.has(key)) {
      uniqueByVerb.set(key, { key, verb });
    }
  });

  const uniqueVerbs = shuffleArray(Array.from(uniqueByVerb.values()));
  const totalSlots = totalRounds * pronouns.length;

  if (uniqueVerbs.length === 0) {
    return [];
  }

  if (uniqueVerbs.length >= totalSlots) {
    return uniqueVerbs.slice(0, totalSlots).map((item, index) => ({
      verb: item.verb,
      pronoun: pronouns[index % pronouns.length],
    }));
  }

  const usedPairs = new Set();
  const verbUseCount = new Map();
  const plan = [];

  const chooseVerb = (pronounId, roundVerbKeys) => {
    const eligible = uniqueVerbs.filter((item) => {
      const pairKey = `${item.key}|${pronounId}`;
      return !usedPairs.has(pairKey) && !roundVerbKeys.has(item.key);
    });

    const pairEligible = uniqueVerbs.filter((item) => {
      const pairKey = `${item.key}|${pronounId}`;
      return !usedPairs.has(pairKey);
    });

    const candidates = eligible.length > 0
      ? eligible
      : pairEligible.length > 0
        ? pairEligible
        : uniqueVerbs;

    const lowestUse = Math.min(...candidates.map((item) => verbUseCount.get(item.key) || 0));
    const leastUsed = candidates.filter((item) => (verbUseCount.get(item.key) || 0) === lowestUse);

    return leastUsed[Math.floor(Math.random() * leastUsed.length)];
  };

  for (let roundIndex = 0; roundIndex < totalRounds; roundIndex += 1) {
    const roundVerbKeys = new Set();

    shuffleArray(pronouns).forEach((pronoun) => {
      const chosen = chooseVerb(pronoun.id, roundVerbKeys);
      const pairKey = `${chosen.key}|${pronoun.id}`;

      usedPairs.add(pairKey);
      roundVerbKeys.add(chosen.key);
      verbUseCount.set(chosen.key, (verbUseCount.get(chosen.key) || 0) + 1);

      plan.push({
        verb: chosen.verb,
        pronoun,
      });
    });
  }

  return plan;
}
